<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'settings.currency.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateCurrency"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'settings.currency.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteCurrency"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['currency'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },
    methods: {
      async deleteCurrency() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('currency/delete', this.currency.id);
          this.$store.dispatch('currency/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateCurrency() {
        this.$router.push('/lists/currencies/update/' + this.currency.id);
      }
    }
  };
</script>
